export default value => (value || 'Ikke udgivet');
